import TNTControlBase from '../../util/TNTControlBase';

class MessageController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super()

    this.id = 'message'
    this.$state = $state
    this.acl = {}
    this.hasACL = {}
  }

  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
      this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }
}

export default MessageController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/message.controller.js